import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
const defaultTimeToImpressionInMilliseconds = 1000;

const useAnalyticsObserver = _ref => {
  let {
    timeToImpression = defaultTimeToImpressionInMilliseconds,
    options = {
      threshold: 0.5,
      fallbackInView: true
    },
    onCreateImpressionWhenView
  } = _ref;
  const {
    ref,
    inView,
    entry
  } = useInView(_objectSpread({}, options));
  useEffect(() => {
    let fired = false;
    let timer = null;

    if (inView) {
      timer = window.setTimeout(() => {
        fired = true;
        onCreateImpressionWhenView === null || onCreateImpressionWhenView === void 0 ? void 0 : onCreateImpressionWhenView(entry);
      }, timeToImpression);
    }

    return () => {
      if (!fired && timer) {
        window.clearTimeout(timer);
      }
    };
  }, [entry, inView, timeToImpression, onCreateImpressionWhenView]);
  return {
    inViewRef: ref
  };
};

export default useAnalyticsObserver;